import React, { Component } from 'react';

import EditorEditIcon from '@atlaskit/icon/glyph/editor/edit';

import Loading from '@qality/common-components/src/atoms/Loading/Loading';
import { TestCycle } from '@qality/common-model';
import {
  StorageOfUniqueServices,
  VersionService,
} from '@qality/common-service';

import VersionSelect, { VersionSelectOption } from '../select/VersionSelect';
import './_test-cycle-details-tab.scss';

type Props = {
  testCycle: TestCycle;
  handleVersionChange: (value: VersionSelectOption) => void;
  canEdit: boolean;
};

type State = {
  showSelect: boolean;
  versionsInitialized: boolean;
  version: VersionSelectOption;
  versions: Array<VersionSelectOption>;
  showMenu: boolean;
};

export default class TestCycleDetailsTabVersion extends Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showSelect: false,
      versionsInitialized: false,
      version: null,
      versions: [],
      showMenu: false,
    };
  }

  async componentDidMount(): Promise<void> {
    this.setState({
      versions: await this.initVersionOptions(this.props.testCycle.project.id),
      versionsInitialized: true,
      version: this.props.testCycle.version
        ? {
            label: this.props.testCycle.version.name,
            value: this.props.testCycle.version.id,
          }
        : {
            label: 'No version',
            value: '',
          },
    });
  }

  initVersionOptions = async (
    projectId: number | string
  ): Promise<Array<VersionSelectOption>> => {
    return VersionService.getVersions(projectId).then((versions) => {
      const versionsOptions = versions.map((version) => {
        return {
          label: version.name,
          value: version.id,
        };
      });
      versionsOptions.unshift({
        label: 'No version',
        value: null,
      });
      return versionsOptions;
    });
  };

  // eslint-disable-next-line complexity
  render(): JSX.Element {
    const testCycle = this.props.testCycle;
    return (
      <div className='test-cycle-details-page-version'>
        <span className='qality-label'>Version:</span>
        {this.state.showSelect ? (
          <div className='test-cycle-details-version-container'>
            {this.state.versionsInitialized ? (
              <VersionSelect
                onChange={(value) => {
                  this.props.handleVersionChange(value);
                  this.setState({ showSelect: false, version: value });
                }}
                selectValue={this.state.version}
                selectValues={this.state.versions}
                autoFocus={true}
                onBlur={() => {
                  this.setState({ showSelect: false });
                }}
              />
            ) : (
              <Loading relative={true} spinnerSize='small' fontSize='small' />
            )}
          </div>
        ) : (
          <span
            className={
              this.props.canEdit
                ? 'test-cycle-details-page-version-container'
                : testCycle.version
                ? 'test-cycle-details-page-version-readonly-container'
                : ''
            }
            onMouseEnter={() => this.setState({ showMenu: true })}
            onMouseLeave={() => this.setState({ showMenu: false })}
          >
            {testCycle.version ? (
              <a
                className='test-cycle-details-page-version-link text-wrapper'
                onClick={async () =>
                  window.open(
                    StorageOfUniqueServices.get('URLService').getVersionUrl(
                      testCycle.project.key,
                      testCycle.version.id
                    ),
                    '_blank'
                  )
                }
              >
                {testCycle.version.name}
              </a>
            ) : (
              <p className='test-cycle-details-page-version-link text-wrapper'>
                No version
              </p>
            )}
            {this.state.showMenu && this.props.canEdit && (
              <span onClick={() => this.setState({ showSelect: true })}>
                <EditorEditIcon size='medium' label='editIcon' />
              </span>
            )}
          </span>
        )}
      </div>
    );
  }
}
